import { useApp } from "@/context/AppContext";
import ProductCard from "@/components/product/ProductCard";
import { Link } from "react-router-dom";

export default function Wishlist() {
  const { wishlist, toggleWishlist } = useApp();
  return (
    <div data-testid="wishlist-page" className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-16">
      <div className="overline text-[#E63946] mb-3">Wishlist</div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter mb-10">SAVED FOR LATER</h1>
      {wishlist.length === 0 ? (
        <div className="border border-dashed border-white/15 py-16 text-center">
          <div className="font-display text-2xl mb-3">Your wishlist is empty</div>
          <p className="text-white/60 mb-6">Save products you love to shop them later.</p>
          <Link to="/shop" className="sa-btn sa-btn-primary">START SHOPPING</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {wishlist.map((w) => (
            <div key={w.id}>
              <ProductCard product={{ ...w, images: w.image ? [w.image] : [], stock: 1 }} />
              <button onClick={() => toggleWishlist(w)} className="mt-2 text-xs text-white/60 hover:text-[#E63946]" data-testid={`wl-remove-${w.id}`}>Remove</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
